import { render, staticRenderFns } from "./VehicleViewRequests.vue?vue&type=template&id=898b424a"
import script from "./VehicleViewRequests.vue?vue&type=script&lang=js"
export * from "./VehicleViewRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports